import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "nativewind/jsx-runtime";
/* eslint-disable no-restricted-imports --
   여기 Touchable 은 편집 모드 전용 추가/삭제 버튼이다 — 계측 대상이 아니다.
   (터치 컴포넌트는 Scc* 사용 원칙: .eslintrc.js no-restricted-imports) */
import React, { useCallback } from 'react';
import { View, Text, TextInput, TouchableOpacity } from 'react-native';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import HtmlContentWrapper from '../components/HtmlContentWrapper';
import { useEditMode } from '../context/EditModeContext';
import { useResponsive } from '../context/ResponsiveContext';
export default function ReviewSection({ reviewSection, sectionId, }) {
    var _a;
    const editContext = useEditMode();
    const isEditMode = (_a = editContext === null || editContext === void 0 ? void 0 : editContext.isEditMode) !== null && _a !== void 0 ? _a : false;
    const { isDesktop } = useResponsive();
    const { titleLine1, titleLine2, descriptionHtmls, descriptionHtmlsMobile, investigatorInfo } = reviewSection;
    // 데스크탑이 아니면 모바일용 HTML 우선 사용
    const displayDescriptionHtmls = isDesktop
        ? descriptionHtmls
        : (descriptionHtmlsMobile || descriptionHtmls);
    const updateReviewSection = useCallback((updates) => {
        if (!editContext)
            return;
        editContext.updateData((prev) => (Object.assign(Object.assign({}, prev), { reviewSection: prev.reviewSection
                ? Object.assign(Object.assign({}, prev.reviewSection), updates) : null })));
    }, [editContext]);
    const handleTitleLine1Change = useCallback((text) => {
        updateReviewSection({ titleLine1: text });
    }, [updateReviewSection]);
    const handleTitleLine2Change = useCallback((text) => {
        updateReviewSection({ titleLine2: text });
    }, [updateReviewSection]);
    const handleAddDescription = useCallback(() => {
        updateReviewSection({
            descriptionHtmls: [...descriptionHtmls, ''],
        });
    }, [descriptionHtmls, updateReviewSection]);
    const handleUpdateDescription = useCallback((index, text) => {
        const newDescriptions = [...descriptionHtmls];
        newDescriptions[index] = text;
        updateReviewSection({ descriptionHtmls: newDescriptions });
    }, [descriptionHtmls, updateReviewSection]);
    const handleRemoveDescription = useCallback((index) => {
        const newDescriptions = descriptionHtmls.filter((_, i) => i !== index);
        updateReviewSection({ descriptionHtmls: newDescriptions });
    }, [descriptionHtmls, updateReviewSection]);
    const handleInvestigatorTitleChange = useCallback((text) => {
        updateReviewSection({
            investigatorInfo: {
                title: text,
                members: (investigatorInfo === null || investigatorInfo === void 0 ? void 0 : investigatorInfo.members) || '',
            },
        });
    }, [investigatorInfo, updateReviewSection]);
    const handleInvestigatorMembersChange = useCallback((text) => {
        updateReviewSection({
            investigatorInfo: {
                title: (investigatorInfo === null || investigatorInfo === void 0 ? void 0 : investigatorInfo.title) || '',
                members: text,
            },
        });
    }, [investigatorInfo, updateReviewSection]);
    return (_jsx("div", { id: sectionId, children: _jsx(Container, { isDesktop: isDesktop, children: _jsxs(ContentWrapper, { isDesktop: isDesktop, children: [_jsx(TitleSection, { children: isEditMode ? (_jsxs(_Fragment, { children: [_jsx(TitleLine1Input, { value: titleLine1, onChangeText: handleTitleLine1Change, placeholder: "\uD0C0\uC774\uD2C0 1\uC904 (\uAC80\uC815)", placeholderTextColor: color.gray40, isDesktop: isDesktop }), _jsx(TitleLine2Input, { value: titleLine2, onChangeText: handleTitleLine2Change, placeholder: "\uD0C0\uC774\uD2C0 2\uC904 (\uD30C\uB791)", placeholderTextColor: color.gray40, isDesktop: isDesktop })] })) : (_jsxs(_Fragment, { children: [_jsx(TitleLine1, { isDesktop: isDesktop, children: titleLine1 }), _jsx(TitleLine2, { isDesktop: isDesktop, children: titleLine2 })] })) }), _jsx(BubbleList, { isDesktop: isDesktop, children: displayDescriptionHtmls.map((html, index) => {
                            const isLeft = index % 2 === 0;
                            return (_jsx(BubbleRow, { isLeft: isLeft, isDesktop: isDesktop, children: isEditMode ? (_jsxs(BubbleEditContainer, { isDesktop: isDesktop, children: [_jsxs(BubbleEditLabel, { children: ["\uD6C4\uAE30 ", index + 1, " (", isLeft ? '왼쪽' : '오른쪽', ")"] }), _jsx(DescriptionInput, { value: html, onChangeText: (text) => handleUpdateDescription(index, text), placeholder: "HTML \uB0B4\uC6A9\uC744 \uC785\uB825\uD558\uC138\uC694", placeholderTextColor: color.gray40, multiline: true }), _jsx(RemoveButton, { onPress: () => handleRemoveDescription(index), children: _jsx(RemoveButtonText, { children: "\uC0AD\uC81C" }) })] })) : (_jsxs(BubbleContainer, { isLeft: isLeft, isDesktop: isDesktop, children: [_jsx(Bubble, { isDesktop: isDesktop, children: _jsx(HtmlContentWrapper, { isDesktop: isDesktop, children: _jsx("div", { dangerouslySetInnerHTML: { __html: html } }) }) }), _jsx(BubbleTailWrapper, { isLeft: isLeft, children: _jsx(BubbleTail, { isLeft: isLeft }) })] })) }, index));
                        }) }), isEditMode && (_jsx(AddButton, { onPress: handleAddDescription, children: _jsx(AddButtonText, { children: "+ \uD6C4\uAE30 \uCD94\uAC00" }) })), (investigatorInfo || isEditMode) && (_jsx(InvestigatorSection, { isDesktop: isDesktop, children: isEditMode ? (_jsxs(_Fragment, { children: [_jsx(InvestigatorTitleInput, { value: (investigatorInfo === null || investigatorInfo === void 0 ? void 0 : investigatorInfo.title) || '', onChangeText: handleInvestigatorTitleChange, placeholder: "\uC870\uC0AC\uB2E8 \uC774\uB984 (\uC608: \uACE0\uCC99\uC2A4\uCE74\uC774\uB3D4 \uC870\uC0AC\uB2E8)", placeholderTextColor: color.gray40 }), _jsx(InvestigatorMembersInput, { value: (investigatorInfo === null || investigatorInfo === void 0 ? void 0 : investigatorInfo.members) || '', onChangeText: handleInvestigatorMembersChange, placeholder: "\uBA64\uBC84 (\uC608: (\uD64D\uAE38\uB3D9, \uAE40\uCCA0\uC218, ...))", placeholderTextColor: color.gray40 })] })) : (investigatorInfo && (_jsxs(_Fragment, { children: [_jsx(InvestigatorTitle, { isDesktop: isDesktop, children: investigatorInfo.title }), _jsx(InvestigatorMembers, { isDesktop: isDesktop, children: investigatorInfo.members })] }))) }))] }) }) }));
}
const Container = styled(View) `
  padding-vertical: ${({ isDesktop }) => (isDesktop ? '140px' : '80px')};
  width: 100%;
  background-color: #ebf5ff;
`;
const ContentWrapper = styled(View) `
  align-items: center;
  gap: ${({ isDesktop }) => (isDesktop ? '30px' : '32px')};
  width: 100%;
  max-width: 1020px;
  align-self: center;
`;
const TitleSection = styled(View) `
  align-items: center;
  gap: 0;
  width: 100%;
  padding: 0 16px;
`;
const TitleLine1 = styled(Text) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '36px' : '24px')};
  font-weight: 700;
  color: ${color.black};
  text-align: center;
  line-height: ${({ isDesktop }) => (isDesktop ? '48px' : '34px')};
`;
const TitleLine2 = styled(Text) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '36px' : '24px')};
  font-weight: 700;
  color: #0e64d3;
  text-align: center;
  line-height: ${({ isDesktop }) => (isDesktop ? '48px' : '34px')};
`;
const TitleLine1Input = styled(TextInput) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '40px' : '24px')};
  font-weight: 700;
  color: ${color.black};
  text-align: center;
  width: 100%;
`;
const TitleLine2Input = styled(TextInput) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '40px' : '24px')};
  font-weight: 700;
  color: #0e64d3;
  text-align: center;
  width: 100%;
`;
const BubbleList = styled(View) `
  width: 100%;
  gap: ${({ isDesktop }) => (isDesktop ? '12px' : '12px')};
`;
const BubbleRow = styled(View) `
  width: 100%;
  padding: 0 16px;
  align-items: ${({ isLeft }) => (isLeft ? 'flex-start' : 'flex-end')};
`;
const BubbleContainer = styled(View) `
  max-width: ${({ isDesktop }) => (isDesktop ? '85%' : '100%')};
  align-items: ${({ isLeft }) => (isLeft ? 'flex-start' : 'flex-end')};
`;
const Bubble = styled(View) `
  background-color: ${color.white};
  border-radius: 12px;
  padding: ${({ isDesktop }) => (isDesktop ? '14px 16px' : '12px 14px')};
`;
const BubbleTailWrapper = styled(View) `
  padding-left: ${({ isLeft }) => (isLeft ? '20px' : '0')};
  padding-right: ${({ isLeft }) => (isLeft ? '0' : '20px')};
  align-items: ${({ isLeft }) => (isLeft ? 'flex-start' : 'flex-end')};
  width: 100%;
`;
const BubbleTail = styled(View) `
  width: 0;
  height: 0;
  border-left-width: 12px;
  border-right-width: 12px;
  border-top-width: 14px;
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: ${color.white};
  transform: ${({ isLeft }) => (isLeft ? 'scaleX(1)' : 'scaleX(-1)')};
`;
const BubbleEditContainer = styled(View) `
  width: 100%;
  gap: 8px;
  background-color: ${color.white};
  border-radius: 12px;
  padding: 16px;
`;
const BubbleEditLabel = styled(Text) `
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 600;
  color: ${color.gray60};
`;
const DescriptionInput = styled(TextInput) `
  font-family: Pretendard;
  font-size: 14px;
  color: ${color.black};
  min-height: 100px;
  background-color: ${color.gray5};
  border-radius: 8px;
  padding: 12px;
`;
const RemoveButton = styled(TouchableOpacity) `
  padding: 8px 16px;
  background-color: ${color.dangerBright};
  border-radius: 8px;
  align-self: flex-start;
`;
const RemoveButtonText = styled(Text) `
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  color: ${color.white};
`;
const AddButton = styled(TouchableOpacity) `
  padding: 16px 32px;
  background-color: ${color.brandBg};
  border-radius: 12px;
`;
const AddButtonText = styled(Text) `
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  color: ${color.brand40};
`;
const InvestigatorSection = styled(View) `
  align-items: center;
  gap: 4px;
  padding: 0 16px;
`;
const InvestigatorTitle = styled(Text) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '16px' : '14px')};
  font-weight: 600;
  color: #0e64d3;
  text-align: center;
  line-height: ${({ isDesktop }) => (isDesktop ? '24px' : '20px')};
`;
const InvestigatorMembers = styled(Text) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '15px' : '13px')};
  font-weight: 400;
  color: #767884;
  text-align: center;
  line-height: ${({ isDesktop }) => (isDesktop ? '22px' : '18px')};
`;
const InvestigatorTitleInput = styled(TextInput) `
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  color: #0e64d3;
  text-align: center;
  min-width: 200px;
  background-color: ${color.white};
  border-radius: 8px;
  padding: 8px 16px;
`;
const InvestigatorMembersInput = styled(TextInput) `
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 400;
  color: #767884;
  text-align: center;
  min-width: 300px;
  background-color: ${color.white};
  border-radius: 8px;
  padding: 8px 16px;
`;
